import { TreeNode } from '@/shared/lib/utils/tree/types';
import { z } from 'zod/v4';

export const NoticeCIImportLinkDTO = z.object({
  type: z.literal('ci_import'),
  job_id: z.uuid().nullish(),
});
export type NoticeCIImportLink = z.infer<typeof NoticeCIImportLinkDTO>;
export type NoticeLink = NoticeCIHealthLink | NoticeCIImportLink;

export const NoticeHeaderCounterDTO = z.object({
  kind: z.enum([
    'total',
    'created',
    'modified',
    'unchanged',
    'skipped',
    'deleted',
    'not_found',
    'errors',
    'links_created',
  ]),
  value: z.number().int().nonnegative(),
});
export type NoticeHeaderCounter = z.infer<typeof NoticeHeaderCounterDTO>;

export class NoticeDTO {
  id: string;
  user_id: string;
  created_at: string;
  data: TreeNode<
    {
      icon: string;
      value: NoticeLiteralValue;
      link?: NoticeLink | null;
      header_counters?: NoticeHeaderCounter[] | null;
      expanded: boolean;
      icon_fill: SeverityValue;
      header: NoticeLiteralValue;
      description: NoticeLiteralValue;
      count: number | null;
      count_firing: number | null;
      count_resolve: number | null;
      count_success: number | null;
      count_warning: number | null;
      count_error: number | null;
      common_annotations: CommonAnnotations;
    },
    'items'
  >;
}

/**
 * Переход на здоровье КЕ из уведомления. Бэкенд кладёт его только в узлы
 * группировки по КЕ и сам выбирает уровень: `hi` - вкладка индикатора,
 * `ci` - вкладка КЕ (значения 0 и 6, на которых вкладка индикатора пуста).
 */
export class NoticeCIHealthLink {
  level: 'hi' | 'ci';
  ci_id: string;
  tql_hi_link_id: string | null;
  hi_type_name: string | null;
}

export class NoticeLiteralValue {
  type: 'literal' | 'cit' | 'hit';
  value: string | null;
}

export class SeverityValue<T extends 'severity' | 'hex' = 'severity'> {
  type: T;
  value: T extends 'severity' ? number : string;
}

export class CommonAnnotations {
  summary: string;
  description: string;
}
